import React from "react";
import { useApp } from "../context/AppContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Files } from "lucide-react";
import { DocTemplatesPanel, CATEGORIES } from "../components/DocTemplatesPanel";

export default function Forms() {
  const { t } = useApp();
  return (
    <div className="space-y-6" data-testid="forms-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-3">
          <Files className="h-7 w-7 text-primary" />{t("forms.title")}
        </h1>
        <p className="text-sm text-muted-foreground mt-1 max-w-3xl">{t("forms.subtitle")}</p>
      </div>
      <Tabs defaultValue="all">
        <TabsList className="mb-4 flex-wrap h-auto">
          <TabsTrigger value="all" data-testid="forms-tab-all">{t("forms.tabAll")}</TabsTrigger>
          {CATEGORIES.map((c) => <TabsTrigger key={c} value={c} data-testid={`forms-tab-${c}`}>{t(`forms.cat.${c}`)}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="all"><DocTemplatesPanel /></TabsContent>
        {CATEGORIES.map((c) => <TabsContent key={c} value={c}><DocTemplatesPanel category={c} /></TabsContent>)}
      </Tabs>
    </div>
  );
}
